import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { supabase } from '../lib/supabaseClient';

function CountryModal({ isOpen, onClose, country, onSuccess }) {
  const [formData, setFormData] = useState({
    code: '',
    name_en: '',
    name_tr: '',
    name_ru: '',
    active: true,
    sort_order: 0,
  });
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isOpen) return;
    if (country) {
      setFormData({
        code: country.code || '',
        name_en: country.name_en || '',
        name_tr: country.name_tr || '',
        name_ru: country.name_ru || '',
        active: country.active !== undefined ? country.active : true,
        sort_order: country.sort_order ?? 0,
      });
    } else {
      setFormData({
        code: '',
        name_en: '',
        name_tr: '',
        name_ru: '',
        active: true,
        sort_order: 0,
      });
    }
  }, [country, isOpen]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((p) => ({ ...p, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const { code, name_en, name_tr, name_ru } = formData;
      if (!code || !name_en || !name_tr || !name_ru) {
        setError('Lütfen tüm zorunlu alanları doldurun.');
        return;
      }
      if (code.length !== 2) {
        setError('Ülke kodu 2 karakter olmalıdır.');
        return;
      }

      const dataToSubmit = {
        ...formData,
        sort_order: parseInt(formData.sort_order, 10) || 0,
        code: formData.code.toUpperCase(),
      };

      console.log(dataToSubmit);
      

      if (country) {
        const { error } = await supabase
          .from('countries')
          .update(dataToSubmit)
          .eq('code', country.code);
        if (error) throw error;
      } else {
        const { error } = await supabase.from('countries').insert([dataToSubmit]);
        if (error) {
          if (error.code === '23505') {
            setError('Bu ülke kodu zaten kullanılıyor.');
            return;
          }

          console.log(error);
          throw error;
        }
      }

      onSuccess();
      onClose();
    } catch (err) {
      console.error('Error saving country:', err);
      setError('Ülke kaydedilirken bir hata oluştu.');
    }
  };

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="w-full max-w-lg rounded-2xl bg-white shadow-xl">
        <div className="flex items-center justify-between border-b px-6 py-4">
          <h2 className="text-lg font-semibold">
            {country ? 'Ülke Düzenle' : 'Yeni Ülke Ekle'}
          </h2>
          <button
            onClick={onClose}
            className="rounded p-1 text-gray-500 hover:bg-gray-100"
            aria-label="Kapat"
          >
            ×
          </button>
        </div>

        <div className="px-6 py-4">
          {error && (
            <div className="mb-4 rounded border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="mb-1 block text-sm font-medium">
                Ülke Kodu (2 karakter) <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="code"
                value={formData.code}
                onChange={handleChange}
                maxLength={2}
                required
                className="w-full rounded-md border px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500 disabled:cursor-not-allowed disabled:bg-gray-100"
                placeholder="TR"
              />
              <small className="text-gray-500">Örnek: TR, US, DE</small>
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium">
                İngilizce Adı <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="name_en"
                value={formData.name_en}
                onChange={handleChange}
                required
                className="w-full rounded-md border px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium">
                Türkçe Adı <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="name_tr"
                value={formData.name_tr}
                onChange={handleChange}
                required
                className="w-full rounded-md border px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium">
                Rusça Adı <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="name_ru"
                value={formData.name_ru}
                onChange={handleChange}
                required
                className="w-full rounded-md border px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium">Sıralama</label>
              <input
                type="number"
                name="sort_order"
                value={formData.sort_order}
                onChange={handleChange}
                className="w-full rounded-md border px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <label className="inline-flex items-center gap-2">
              <input
                type="checkbox"
                name="active"
                checked={formData.active}
                onChange={handleChange}
                className="h-4 w-4 rounded border-gray-300"
              />
              <span>Aktif</span>
            </label>

            <div className="pt-2">
              <button
                type="submit"
                className="w-full rounded-md bg-[#4263EB] px-4 py-2 font-medium text-white hover:bg-[#3b5bd9]"
              >
                {country ? 'Güncelle' : 'Ekle'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default CountryModal;